// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"706":"110c063d244464c4","3140":"f3d2992f28306ae6","5187":"e74f114083563c1a","5316":"62e85518bdac4e02","6726":"6d0536fa12160466"}[chunkId] + ".css";
};